/**
 * Mock for DiaryService (see main service for full details)
 */


import {of as observableOf,  Observable } from 'rxjs';

import {delay} from 'rxjs/operators';




import moment from 'moment';

import { Injectable } from '@angular/core';

import {
  CalendarEventAction,
} from 'angular-calendar';

import {
  DiaryEvent,
  EventType,

  CommitEventResponse,
  FetchEventsResponse,
  FetchEventTypesResponse,
} from '../models/diary';

@Injectable()
export class DiaryService {

  addEvent(req: DiaryEvent): Observable<CommitEventResponse> {
    const valid = req.id === null;
    return observableOf({
        error: valid ? null : 'Cannot specify an ID when adding an event',
        id:    null,
        newId: Math.floor(Math.random() * 100000).toString(),
      }).pipe(
      delay(1000));
  }

  bookEvent(id: string): Observable<CommitEventResponse> {
    const valid = id !== null;
    return observableOf({
      error: valid ? null : 'Please specify an event ID to book',
      id,
    });
  }

  deleteEvent(id: string): Observable<CommitEventResponse> {
    const valid = id !== null;
    return observableOf({
        error: valid ? null : 'Please specify an event ID to delete',
        id,
      }).pipe(
      delay(1000));
  }

  fetchEvents(): Observable<FetchEventsResponse> {
    const items: DiaryEvent[] = [];
    for (let i = 0; i < 25; i++)
      items.push(DiaryEvent.getExample());

    return observableOf({
        error: null,
        items,
      }).pipe(
      delay(1000));
  }

  fetchEventTypes(): Observable<FetchEventTypesResponse> {
    return observableOf({
        error: null,
        types: [
          { id: '0', name: 'Service' },
          { id: '1', name: 'Installation' },
          { id: '2', name: 'Training' },
          { id: '3', name: 'Meeting' },
          { id: '4', name: 'Quote' },
          { id: '5', name: 'Customer visit' },
          { id: '6', name: 'Other' }
        ],
      }).pipe(
      delay(1000));
  }

  updateEvent(req: DiaryEvent): Observable<CommitEventResponse> {
    const valid = req.id !== null;
    return observableOf({
        error: valid ? null : 'Please specify an event ID to update',
        id:    req.id
      }).pipe(
      delay(1000));
  }

}
